import { LocaleService } from '../../services/locale/locale.service';

/**
 * Angular filter: localizeDate
 *
 * Replaces the built-in Angular `| date:'pattern'` filter for display dates.
 * Delegates to LocaleService so output is locale-aware (en-AU, en-US, fr-CA…).
 *
 * Usage in templates:
 *   {{ vm.date | localizeDate:'short' }}        → 03/10/2026  (en-AU)
 *   {{ vm.date | localizeDate:'medium' }}       → 3 Oct 2026
 *   {{ vm.date | localizeDate:'full' }}         → Thursday 3 October 2026
 *
 * For combined datetime strings, keep the time portion with the native `| date` filter
 * and apply localizeDate only to the date portion:
 *   {{ vm.date | date:'h:mm a' }} {{ vm.date | localizeDate:'full' }}
 *
 * See LocaleService for the full list of preset keys.
 */
export function localizeDateFilter() {
  return function(date: Date | string, preset: string): string {
    if (!date) return '';
    return LocaleService.formatDate(date, preset as any);
  };
}

localizeDateFilter.$inject = [] as any;
